import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { approveStep, getApprovalStep, unapproveStep } from "../actions";
import _ from "lodash";
import { getCurrentUser } from "modules/current_user/actions";

import { useHistory } from "react-router-dom";
import { Page, Block, Button, BlockTitle, Navbar } from "framework7-react";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";

function mapStateToProps(state) {
  return {
    approval_steps: state.approval_steps,
    current_user: state.current_user,
  };
}

const ApproveStep = (props) => {
  const {
    approval_steps,
    current_user,
    approval,
    f7router,
    f7router: { app },
  } = props;
  const approval_step_id = props?.id;

  const approval_step = approval_steps[approval_step_id];
  const [modalOpen, setModalOpen] = React.useState(false);
  const toggle = () => setModalOpen(!modalOpen);

  useEffect(() => {
    if (!approval_step) {
      app.preloader.show();
      props.getApprovalStep(approval_step_id).then(() => {
        app.preloader.hide();
      });
    }
  }, []);

  let label;

  if (_.includes(approval_step?.user_ids, current_user.id) === false) {
    label = `Only ${approval_step?.users} can approve this.`;
  }

  let approvable = true;
  if (approval?.steps) {
    const previous_steps = approval.steps.filter((s) => s.step_number < approval_step.step_number);
    if (previous_steps.length > 0) {
      approvable = _.every(previous_steps, (s) => s.approved === true);
    }
  }
  if (!approvable) {
    label = `Requires previous step/s to be approved first`;
  }

  let unapprovable = approval_step?.approved;
  if (approval?.steps) {
    const subsequent_steps = approval.steps.filter((s) => s.step_number > approval_step.step_number);
    if (subsequent_steps.length > 0) {
      unapprovable = _.every(subsequent_steps, (s) => s.approved === false);
    }
  }
  if (approval_step?.approved && !unapprovable) {
    label = `Requires subsequent step/s to be unapproved first`;
  }

  if (approval_step?.approved) {
    label = `This step has already been approved`;
  }

  if (label) {
    return (
      <Page>
        <Navbar title="Already Approved" backLink/>
        <Block>{label}</Block>
      </Page>
    );
  }

  return (
    <Page>
      <Navbar title="Approve Request" />
      <BlockTitle>Content</BlockTitle>
      <Block>
        {approval_step?.approval_content}

        {approval_step?.approval_report_link && (
          <Fragment>
            <hr />
            <Button fill external target="_blank" href={approval_step.approval_report_link}>
              View Report
            </Button>
          </Fragment>
        )}
      </Block>
      <hr />

      <Block>Are you sure you want to {approval_step?.approved ? <b>unapprove</b> : <b>approve</b>} this request?</Block>
      <Block>
        <Button
          fill
          color={approval_step?.approved ? "red" : "green"}
          className="margin"
          onClick={() => {
            app.preloader.show();
            let request;
            if (approval_step?.approved) {
              request = props.unapproveStep(approval_step_id);
            } else {
              request = props.approveStep(approval_step_id);
            }
            request.then(() => {
              props.getCurrentUser();
              app.preloader.hide();
              app.toast
                .create({
                  icon: '<i class="material-icons">check</i>',
                  text: `${approval_step?.approved ? "Unapproved" : "Approved"}`,
                  position: "center",
                  closeTimeout: 2000,
                  on: {
                    opened: () => {
                      f7router.navigate(`/approvals`);
                    },
                  },
                })
                .open();
            });
            request.catch((err) => {
              app.preloader.hide();
              f7router.navigate(`/approvals`);
            });
          }}
        >
          Yes
        </Button>
        <Button
          color={approval_step?.approved ? "green" : "red"}
          className="margin"
          fill
          onClick={() => {
            f7router.navigate(`/approvals`);
          }}
        >
          No
        </Button>
      </Block>
    </Page>
  );
};

export default connect(mapStateToProps, { getApprovalStep, approveStep, unapproveStep, getCurrentUser })(ApproveStep);

{
  /* <Card>
<CardHeader toggle={toggle}>Approve Request</CardHeader>
<CardBody>
  Are you sure you want to {approval_step?.approved ? "unapprove" : "approve"} this request?
  <br />
  <div className="border p-1 m-2">{approval_step?.approval_content}</div>
  {approval_step?.approval_report_link && (
    <iframe src={approval_step?.approval_report_link} style={{ width: "100%", height: "600px", border: "none" }}></iframe>
  )}
</CardBody>
<CardFooter>
  <Row>
    <Col>
      <Button
        color="success"
        onClick={() => {
          props
            .approveStep(approval_step_id)
            .then(() => {
              toastr.success("Approved");
              history.push("/approvals");
            })
            .catch((err) => {
              setModalOpen(false);
            });
        }}
      >
        Yes
      </Button>
    </Col>
    <Col>
      <Button
        color="secondary"
        onClick={() => {
          history.push("/approvals");
        }}
      >
        No
      </Button>
    </Col>
  </Row>
</CardFooter>
</Card> */
}
